module.exports = __webpack_public_path__ + "img/title.821729d7.png";